import { useCallback, useEffect, useState } from "react";
import { fetchFounderGrowthDashboard, FounderGrowthDashboard } from "../services/founderGrowthService";

type FounderGrowthState = {
  data: FounderGrowthDashboard | null;
  error: string | null;
  isLoading: boolean;
  lastUpdated: Date | null;
  refresh: () => Promise<void>;
};

export function useFounderGrowth(): FounderGrowthState {
  const [data, setData] = useState<FounderGrowthDashboard | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState<Date | null>(null);

  const refresh = useCallback(async () => {
    setIsLoading(true);

    try {
      const result = await fetchFounderGrowthDashboard();
      setData(result);
      setError(result.error);
      setLastUpdated(result.lastUpdated);
    } catch {
      setData(null);
      setError("Unable to load Founder Growth.");
      setLastUpdated(new Date());
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    data,
    error,
    isLoading,
    lastUpdated,
    refresh
  };
}
